import { render, staticRenderFns } from "./ReportTraining.vue?vue&type=template&id=68e4c7f9&scoped=true"
import script from "./ReportTraining.vue?vue&type=script&lang=js"
export * from "./ReportTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e4c7f9",
  null
  
)

export default component.exports